import { Injectable, inject } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

/** this service uses thumbnail encoded base64 url
 * and converts it to safe sanitized url */
@Injectable({ providedIn: 'root' })
export class ThumbnailUrlService {
  private sanitizer = inject(DomSanitizer);

  getSafeUrl(thumbnail: string | undefined): SafeResourceUrl | undefined {
    return thumbnail
      ? this.sanitizer.bypassSecurityTrustResourceUrl(
          'data:image/jpg;base64,' + thumbnail
        )
      : undefined;
  }
}
